import { render, staticRenderFns } from "./ShipmentCreatePopup.vue?vue&type=template&id=b13f8c02&scoped=true"
import script from "./ShipmentCreatePopup.vue?vue&type=script&lang=js"
export * from "./ShipmentCreatePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13f8c02",
  null
  
)

export default component.exports